import React, { createContext, useContext, useEffect, useState } from 'react';
import Cookies from 'js-cookie';
import { getUser } from '../authentication/authentication.service';
import { AuthenticationContext } from '../authentication/authentication.context';
import { urlConfig } from '../../config/urlConfig';
import { accessTokenRequest, sendRequest } from '../global/global.service';
import moment from 'moment';

export const ProfileContext = createContext();

const default_profile = '/icons/default_profile.png';

const default_userTimeZone = moment.tz.guess();

export const ProfileContextProvider = ({ children }) => {
  const {
    userData,
    setUserData,
    userPreferTime,
    setUserPreferTime,
    getUserTimeZone,
  } = useContext(AuthenticationContext);

  const [user, setUser] = useState(userData);
  const [userLocation, setUserLocation] = useState(null);
  const [tempLocation, setTempLocation] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [profileImage, setProfileImage] = useState({
    default: default_profile,
    value: '',
    error: '',
    blob: '',
  });

  useEffect(() => {
    // when user has been login
    if (user) {
      user.avatar
        ? setProfileImage({
            value: '',
            error: '',
            blob: '',
            default: user.avatar,
          })
        : setProfileImage({
            value: '',
            error: '',
            blob: '',
            default: default_profile,
          });
      if (user.lat && user.lng) {
        setUserLocation({ lat: user.lat, lng: user.lng });
      } else {
        setUserLocation(null);
      }

      getUserTimeZone();
    } else {
      // First time after registration or login
      setUser(userData);

      getUserTimeZone();
      if (userData && userData.lat && userData.lng) {
        setUserLocation({ lat: userData.lat, lng: userData.lng });
      } else {
        setUserLocation(null);
      }
      Cookies.get('refresh_token') &&
        Cookies.get('access_token') &&
        getUser(setUser, setUserData, setUserLocation);
    }
  }, [setUserData, user, userData]);

  //check is connect
  const checkIsConnect = (setLoading, setIsConnect, userData) => {
    setLoading(true);

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.check_is_connect, response, 'post', userData)
          .then((res) => {
            setLoading(false);

            if (res.status && res.status === 200) {
              setIsConnect(true);
              return true;
            } else {
              setIsConnect(false);
              return false;
            }
          })
          .catch((e) => {
            setLoading(false);
            setIsConnect(false);
          });
      })
      .catch((e) => {
        setLoading(false);
        setIsConnect(false);
      });
  };

  const saveUserTimeZone = (preferTime, timeZone) => {
    if (preferTime && preferTime.user_timezone === null) {
      accessTokenRequest()
        .then((response) => {
          sendRequest(urlConfig.time_algorithm_url, response, 'post', {
            ...preferTime,
            user_timezone: timeZone,
          })
            .then((res) => {
              setUserPreferTime(res.data);
            })
            .catch((e) => {});
        })
        .catch((e) => {});
    }
  };

  const changeProfileImage = (e) => {
    const formData = new FormData();
    setIsLoading(true);
    profileImage &&
      profileImage.blob &&
      formData.append('avatar', profileImage.blob, 'photo.jpeg');

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.user_url, response, 'patch', formData)
          .then((res) => {
            setIsLoading(false);
            setUser(res.data);
          })
          .catch((e) => {
            setIsLoading(false);
            setError(e.response);
          });
      })
      .catch();
  };

  const saveUserLocation = (setIsLoading, setShow) => {
    setIsLoading(true);

    const data = {
      first_name: user.firstName,
      last_name: user.last_name,
      birthdate: user.birthdate,
      gender: user.gender,
      email: user.email,
      about_me: user.about_me ? user.about_me : null,
      phonenumber: user.phonenumber,
      lat: tempLocation && tempLocation.lat,
      lng: tempLocation && tempLocation.lng,
    };

    accessTokenRequest()
      .then((response) => {
        sendRequest(urlConfig.user_url, response, 'patch', data)
          .then((res) => {
            setUser(res.data);
            setIsLoading(false);
            setShow(true);
          })
          .catch((e) => {
            setIsLoading(false);
            setError(e.toString());
            setShow(false);
          });
      })
      .catch((e) => {
        setIsLoading(false);
        setError(e.toString());
        setShow(false);
      });
  };

  useEffect(() => {
    userPreferTime && saveUserTimeZone(userPreferTime, default_userTimeZone);
  }, [user, userPreferTime]);

  return (
    <ProfileContext.Provider
      value={{
        isLoading,
        error,
        user,
        profileImage,
        default_profile,
        userLocation,
        setTempLocation,
        checkIsConnect,
        setProfileImage,
        setUser,
        changeProfileImage,
        saveUserLocation,
      }}
    >
      {children}
    </ProfileContext.Provider>
  );
};
